<template>
  <div class="ecl-form-group">
    <label for="select-default" class="ecl-form-label">{{ label }}</label>
    <div class="ecl-select__container">
      <select class="ecl-select" id="select-default" required="" v-model="selected">
        <option v-for="option in options" :value="getId(option)" :key="getId(option)">{{ getLabel(option) }}</option>
      </select>
      <div class="ecl-select__icon">
        <svg class="ecl-icon ecl-icon--s ecl-icon--rotate-180 ecl-select__icon-shape" focusable="false" aria-hidden="true">
          <use xlink:href="@/../node_modules/@ecl/preset-ec/dist/images/icons/sprites/icons.svg#corner-arrow" />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ECSelect",
  props: {
    label: String,
    value: [String, Number],
    options: Array
  },
  data() {
    return {
      selected: this.value
    }
  },
  methods: {
    getId(item) {
      return typeof item === 'string' ? item : item.id;
    },
    getLabel(item) {
      return typeof item === 'string' ? item : item.label;
    },
  },
  watch: {
    selected() {
      this.$emit('input', this.selected);
    },
    value() {
      this.selected = this.value;
    }
  }
}
</script>

<style scoped>

</style>
